import { MenuT } from 'types/frontend/Menu';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const billMenuRootPath = '/teacherSide/bill';
const billMenu: MenuT = [
  {
    title: t('학원비 설정'),
    items: [
      {
        title: t('사업자별 정보 설정'),
        path: `${billMenuRootPath}/corpSetting/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('자주 쓰는 학원비 항목'),
        path: `${billMenuRootPath}/preset/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('청구서 템플릿 관리'),
        path: `${billMenuRootPath}/template/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
  {
    title: t('청구서'),
    items: [
      {
        title: t('청구서 작성/수정'),
        path: `${billMenuRootPath}/group/add`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('작성된 청구서 리스트'),
        path: `${billMenuRootPath}/group/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      // {
      //   title: t('학원비 통장'),
      //   path: `${billMenuRootPath}/account`,
      // },
    ],
  },
  {
    title: t('조회'),
    items: [
      {
        title: t('기간별 수납 내역'),
        path: `${billMenuRootPath}/payment/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('미납 리스트'),
        path: `${billMenuRootPath}/unpaidBill/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('월별 매출/수납'),
        path: `${billMenuRootPath}/stats`,
        accessablePositions: ['director', 'assistantDirector'],
        domainVisibilityCriteria: (domainSetting, myInfo) => {
          const teacher = myInfo?.teacherInfo?.teacher;

          return (
            teacher?.position === 'director' ||
            (teacher?.position === 'assistantDirector' &&
              teacher.isFinancialManager === true &&
              domainSetting.bill?.sumsAssistantDirectorVisible === true)
          );
        },
      },
    ],
  },
  {
    title: t('현금영수증'),
    items: [
      {
        title: t('현금영수증 정보 관리'),
        path: `${billMenuRootPath}/cashBill/info`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('현금영수증 발급'),
        path: `${billMenuRootPath}/cashBill/issueWOBill`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('현금영수증 발급 기록'),
        path: `${billMenuRootPath}/cashBill/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
  {
    title: t('영수증'),
    items: [
      {
        title: t('교습비 영수증'),
        path: `${billMenuRootPath}/receipt`,
      },
      {
        title: t('교육비 납입 증명서'),
        path: `${billMenuRootPath}/eduExpenseCertificate`,
      },
    ],
  },
];

export { billMenu };
